import { Crm6Import } from "@/components/crm-demos/crm-6-import"
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_crm-demos/crm-6")({
  component: Crm6Page,
  head: () => ({ meta: [{ title: "CRM 6 · CSV Import Wizard" }] }),
});

function Crm6Page() {
  return <Crm6Import />
}
